<script setup lang="ts">
  import {
    Card,
    CardContent,
    CardFooter,
    CardHeader,
    CardTitle,
  } from "@/components/ui/card"
  import { Skeleton } from "@/components/ui/skeleton"
</script>

<template>
  <Card data-testid="meter-readings-card-skeleton">
    <CardHeader>
      <CardTitle>Meter Readings</CardTitle>
    </CardHeader>
    <CardContent>
      <div class="flex flex-col gap-3">
        <Skeleton class="h-[24px] w-[250px] sm:h-[28px]" />
        <div class="flex flex-col gap-2">
          <Skeleton class="h-[24px] w-[250px] sm:h-[28px]" />
          <Skeleton class="h-[24px] w-[250px] sm:h-[28px]" />
        </div>
      </div>
    </CardContent>
    <CardFooter>
      <div class="flex flex-col items-end">
        <Skeleton
          class="mb-2.5 h-[36px] w-full sm:mb-3 sm:w-[136px]"
          variant="rounded"
        />
        <Skeleton class="h-[36px] w-full sm:w-[217px]" variant="rounded" />
      </div>
    </CardFooter>
  </Card>
</template>
